import { Component, EventEmitter, Input, OnInit, Output, HostListener } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { GlobalConstants } from '../../constants/global-constants';

@Component({
  selector: 'app-rat-multiselect',
  templateUrl: './rat-multiselect.component.html',
  styleUrls: ['./rat-multiselect.component.css']
})
export class RatMultiselectComponent implements OnInit {

  @Input() question!: any;
  @Input() eachControl!: any;
  @Input() controlIndex!: number;
  @Input() form!: FormGroup;
  @Input() assessmentType!: string;
  @Output() inputChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() isSubmittedEvent!: Observable<void>;

  isArabic!: boolean;
  isValid!: boolean;
  controlValue: any;

  checkedList: any[] = [];
  arabicCheckedList: any[] = [];
  currentSelected!: {};
  showDropDown = false;
  isDisabled: any;

  constructor(private storageService: StorageService, private fb: FormBuilder) { }

  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (event.target.id != 'multiselectCustom' && this.showDropDown) {
      this.showDropDown = false;
    }
  }
  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isDisabled = this.eachControl.isDisabled;
    let initialcheckedList = [];
    if (this.assessmentType === 'mainAssessment') {
      if (this.eachControl?.value == null || this.eachControl?.value == undefined ||
        // this.eachControl?.value == 'N/A'
        this.eachControl?.value == GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT
      ) {
        this.checkedList = [];
      } else {
        initialcheckedList = this.eachControl?.value?.split(',');
      }
      //console.log('input ques: --- ', this.question.quesId + '_id_' + this.controlIndex, ' ans: --- ', this.eachControl?.value);
      // this.form.controls[this.question.quesId+'_id_'+this.controlIndex].setValue(this.controlValue);
      this.eachControl?.options.forEach((element: any, idx: any) => {
        this.eachControl.options[idx].checked = false;
      });
      initialcheckedList.forEach((ele: any, i: any) => {
        this.eachControl?.options.forEach((element: any, idx: any) => {
          if (ele == element.value) {
            this.eachControl.options[idx].checked = true;
            this.arabicCheckedList.push(element.valueArabic);
            this.checkedList.push(element.value);
          }
          else if (ele == element.valueArabic) {
            this.eachControl.options[idx].checked = true;
            this.arabicCheckedList.push(element.valueArabic);
            this.checkedList.push(element.value);
          }
        });
      });
      if (this.isArabic && this.arabicCheckedList.length > 0) {
        // this.checkedList = this.arabicCheckedList.reverse();
        this.arabicCheckedList = this.arabicCheckedList.reverse();
      }
      //console.log('multiselect options: ', this.eachControl?.options);

      this.isSubmittedEvent.subscribe(() => {
        this.setValidation(this.checkedList, this.question.quesId + '_id_' + this.controlIndex);
      });

    }
  }

  toggleShowDropdown() {
    if (this.eachControl.isDisabled) {

    } else {
      this.showDropDown = !this.showDropDown;
    }
  }


  getSelectedValue(opt: any, idx: any, parentQuesId: any) {
    this.eachControl.options[idx].checked = !this.eachControl.options[idx]?.checked;
    //console.log('opt is: ', opt);
    if (this.eachControl.options[idx].checked) {
      // this.checkedList.push(opt.value);
      if (this.isArabic) {
        this.checkedList.push(opt.value);
        this.arabicCheckedList.push(opt.valueArabic);
        // this.checkedList = this.arabicCheckedList.reverse();
        this.arabicCheckedList = this.arabicCheckedList.reverse();
      } else {
        this.checkedList.push(opt.value);
      }
    } else {
      var index = this.checkedList.indexOf(opt.value);
      // var index = this.isArabic ? this.checkedList.indexOf(opt.valueArabic) : this.checkedList.indexOf(opt.value);
      this.checkedList.splice(index, 1);
    }
    //console.log('checkedList : ', this.checkedList);
    this.setValidation(this.checkedList, parentQuesId);
  }

  setValidation(selectedVal: any, parentQuesId: any) {
    //console.log(this.isValid);
    //console.log('input validation: ', selectedVal);
    let selectedValueIndexArr: any = [];
    if (selectedVal.length <= 0) {
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].setErrors({ 'required': true });
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].markAsTouched();
      this.isValid = false;
    } else {
      this.isValid = true;
      selectedVal.forEach((val: any) => {
        selectedValueIndexArr.push(this.eachControl?.options?.findIndex((x: any) => x.value == val))
      })
    }
    let selectedValues = selectedVal.toString();
    //console.log('validation', { parentQuesId, parentQuesValue: selectedValues, quesValid: this.isValid, index: this.controlIndex })
    this.inputChanged.emit({
      parentQuesId, parentQuesValue: selectedValues, quesValid: this.isValid, index: this.controlIndex,
      selectedValueIndex: selectedValueIndexArr
    });
  }

}
